module.exports = __webpack_public_path__ + "img/Dropbox.ca11c2cf.png";